import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1440 1024"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M1440 0h-.5v239.231c-3.16 24.594-9.79 82.166-32.48 121.852-83.72 146.445-334.12 197.777-367.24 210.166-29.84 11.163-58.781 20.122-86.388 28.669-117.539 36.389-158.444 64.676-247.382 225.095C622.846 975.016 341.694 1020.9 124.579 1024H1440z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#currentColor",
  d: "M89.6 1024c-32.814-.49-63.104-2.38-89.6-5.59v5.59z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }